import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Organization } from "@racoon/api";

type CompanyState = {
  selectedCompanyId: number | null;
  selectedCompany: Organization | null;
};

export const COMPANY_STORAGE_KEY = "selected_company";

function loadPersisted(): CompanyState {
  try {
    const raw = localStorage.getItem(COMPANY_STORAGE_KEY);
    if (!raw) return { selectedCompanyId: null, selectedCompany: null };
    return JSON.parse(raw);
  } catch {
    return { selectedCompanyId: null, selectedCompany: null };
  }
}

const initialState: CompanyState = loadPersisted();

const slice = createSlice({
  name: "company",
  initialState,
  reducers: {
    setSelectedCompany(state, action: PayloadAction<Organization>) {
      state.selectedCompanyId = action.payload.id;
      state.selectedCompany = action.payload;
      localStorage.setItem(COMPANY_STORAGE_KEY, JSON.stringify(state));
    },
    setSelectedCompanyById(state, action: PayloadAction<number>) {
      state.selectedCompanyId = action.payload;
      state.selectedCompany =
        state.selectedCompany?.id === action.payload ? state.selectedCompany : null;
      localStorage.setItem(COMPANY_STORAGE_KEY, JSON.stringify(state));
    },
    clearSelectedCompany(state) {
      state.selectedCompanyId = null;
      state.selectedCompany = null;
      localStorage.removeItem(COMPANY_STORAGE_KEY);
    },
  },
});

export const { setSelectedCompany, setSelectedCompanyById, clearSelectedCompany } = slice.actions;
export const companyReducer = slice.reducer;
